import React, { useEffect, useState } from "react";
import { MdErrorOutline, MdOutlineAccessTime, MdOutlineLocationOn, MdOutlineEventAvailable, MdOutlineCalendarMonth, MdInfoOutline } from "react-icons/md";
import { useToast } from "../../controls/Toast/ToastService";
import Card from "../../controls/Card";
import { GetAllByUserPublic } from "../../../configurations/crud/opdCentersCrud";
import LoadingContainer from "../../controls/LoadingContainer";
import { GetEBoolName } from "../../../configurations/enums/EBool";
import StatusContainer from "../../controls/StatusContainer";
import { EDoctorStatusBg, GetEDoctorStatusName } from "../../../configurations/enums/EDoctorStatus";
import User from "../users/User";
import moment from 'moment'
import { GetEOpdDaysName } from "../../../configurations/enums/EOpdDays";
import { useNavigate, useParams } from "react-router-dom";
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { IoCheckmarkDoneCircleOutline } from "react-icons/io5";
import { IoMdAdd } from "react-icons/io";
import { HiOutlineWifi } from "react-icons/hi2";
import AddOpdOnline from "../opdlive/AddOpdOnline";
import MasterPage from "../MasterPage";
import useGlobalLoader from "../../../configurations/useGlobalLoader";
import FavoriteButton from "../publicUsers/FavoriteButton";


export default function CenterAllByUserPublic() {
  const TODAYS_DATE = new Date()
  const { start, end } = useGlobalLoader()
  const [opdCenters, setOpdCenter] = useState([]);
  const [selectedCenter, setSelectedCenter] = useState();
  const [user, setUser] = useState();
  const [loding, setLoding] = useState(false);
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isOpenAdd, setIsOpenAdd] = useState(false)
  const [centerId, setCenterId] = useState()
  const [centerName, setCenterName] = useState()
  const toast = useToast();
  const { doctorId } = useParams()
  const navigate = useNavigate()

  useEffect(() => { getAllOpdCenters() }, []);

  function getAllOpdCenters() {
    setLoding(true); start()
    GetAllByUserPublic({ DoctorId: doctorId })
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          if (mdata.data.length > 0) setUser(mdata.data[0].user)
          setOpdCenter(mdata.data);
        } else { setOpdCenter([]); toast.open(mdata.result.message, <MdErrorOutline />, "danger"); }
        setLoding(false); end()
      })
      .catch(() => { setOpdCenter([]); setLoding(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) });
  }

  // open the register modal for a center
  const openRegister = (item) => {
    setCenterName(item.centerName);
    setCenterId(item.id);
    setSelectedCenter(item);
    setIsOpenAdd(true);
  }

  const addOpdOnline = (param, setValues) => {
    setLodingCrud(true); start()
    opdRegisteredCrud.AddOnline(param).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setValues({ opdCenterId: centerId, patientName: "", mobile: "", bloodGroup: "", bloodPressure: "", weight: "", age: "", gender: 0, type: 0, note: "", cityId: "", stateId: "", patientAddress: "" })
        setIsOpenAdd(false)
        navigate(`/checkregister/${mdata.data.id}`)
        toast.open("Opd added successfully.", <IoCheckmarkDoneCircleOutline />, "success", 5000)
      } else { toast.open(mdata.result.message, <MdErrorOutline />, "danger", 5000) }
      setLodingCrud(false); end()
    }).catch(() => { setLodingCrud(false); end(); toast.open("Internet not connected, please connect and refresh", <MdErrorOutline />, "danger", 5000) })
  }

  // responsive info row: label + value
  const Info = ({ icon, label, children }) => (
    <div className="flex items-start gap-3 px-1 py-2 border-b border-gray-50 last:border-0">
      <span className="mt-0.5 shrink-0 grid place-items-center h-7 w-7 rounded-lg bg-gray-50 text-base">{icon}</span>
      <div className="flex-1 min-w-0 flex flex-col sm:flex-row sm:items-center sm:gap-2">
        <span className="text-xs font-semibold uppercase tracking-wide text-gray-400 sm:w-40 sm:shrink-0">{label}</span>
        <span className="text-sm text-gray-700 break-words">{children}</span>
      </div>
    </div>
  )

  return (
    <MasterPage>
      {!loding ?
        user ?
          <div className="w-full flex flex-col md:flex-row gap-4 px-2 sm:px-4 pb-4">
            {/* doctor sidebar */}
            <div className="w-full md:w-4/12 lg:w-3/12 md:sticky md:top-[80px] self-start">
              {user &&
                <div className="relative">
                  <FavoriteButton item={user} className="absolute top-3 right-3 z-10" />
                  <User user={user} isBorder={true} borderColor='border-green-300' isBack={true} title={"OPD Centers"} />
                </div>}
            </div>

            {/* centers */}
            <div className="flex flex-col gap-4 w-full md:w-8/12 lg:w-9/12">
              {opdCenters.map((item, index) => {
                const isOnline = item.isRegisterOnline == 1
                return (
                  <div key={index} onClick={() => { if (isOnline) openRegister(item) }} className={isOnline ? "cursor-pointer" : ""}>
                    <Card isBorder={true} borderColor='border-brand-300' title={item.centerName}
                      actions={isOnline
                        ? <span className="chip bg-emerald-50 text-emerald-700"><HiOutlineWifi /> Online</span>
                        : <span className="chip bg-gray-100 text-gray-500">Offline</span>}>
                      <div className="text-gray-700">
                        {isOnline &&
                          <Info icon={<MdOutlineEventAvailable className="text-brand-500" />} label="Register Appointment">
                            {item.opdType == 0
                              ? <>{moment(item.startPuttingAppointment).format("LT")} – {moment(item.endPuttingAppointment).format("LT")}</>
                              : <>{moment(TODAYS_DATE).format("DD/MM/YYYY")} to {moment(TODAYS_DATE.setDate(TODAYS_DATE.getDate() + parseInt(item.byDaysCount))).format("DD/MM/YYYY")}</>}
                          </Info>}

                        <Info icon={<MdOutlineAccessTime className="text-lime-600" />} label="OPD Timing">
                          {moment(item.opdStartTime).format("LT")} – {moment(item.opdEndTime).format("LT")}
                        </Info>

                        <Info icon={<MdOutlineCalendarMonth className="text-purple-500" />} label="Opens">
                          <span className="flex flex-wrap gap-1">
                            {item.opdDays.split(',').map((d, i) =>
                              <span key={i} className="chip bg-brand-50 text-brand-700 !px-2 !py-0.5">{GetEOpdDaysName(d.trim())}</span>
                            )}
                          </span>
                        </Info>

                        <Info icon={<MdOutlineLocationOn className="text-blue-500" />} label="Address">
                          {item.address}, {item.city.name}, {item.city.state.name} · {item.phone}
                        </Info>

                        <Info icon={<MdInfoOutline className="text-gray-400" />} label="Doctor's Status">
                          <StatusContainer bg={EDoctorStatusBg(item.doctorStatus)} text={GetEDoctorStatusName(item.doctorStatus)} />
                        </Info>

                        {item.user.isOnLeave !== 0 &&
                          <>
                            <Info icon={<MdInfoOutline className="text-rose-500" />} label="On Leave">
                              <StatusContainer bg={`${item.user.isOnLeave == 0 ? "bg-green-400" : "bg-red-400"}`} text={GetEBoolName(item.user.isOnLeave)} />
                            </Info>
                            {item.user.leaveNote &&
                              <Info icon={<MdInfoOutline className="text-rose-400" />} label="Leave Note">{item.user.leaveNote}</Info>}
                          </>}

                        {item.details &&
                          <Info icon={<MdInfoOutline className="text-amber-500" />} label="Detail">{item.details}</Info>}

                        {isOnline &&
                          <div className="flex justify-end pt-3">
                            <button type="button" title="Register"
                              onClick={(e) => { e.stopPropagation(); openRegister(item) }}
                              className="inline-flex items-center gap-1.5 px-4 py-2 text-white bg-gradient-to-b from-brand-400 to-brand-500 rounded-xl shadow-brand hover:brightness-105 active:scale-95 transition">
                              <IoMdAdd className="text-lg" />
                              <span className="text-sm font-semibold">Create Appointment</span>
                            </button>
                          </div>}
                      </div>
                    </Card>
                  </div>
                )
              })}
            </div>
          </div>
          :
          <div className="w-full px-2 sm:px-4 pb-4">
            <Card title={"Not Found"} isBorder={true} isBack={true} borderColor='border-green-300'>
              <div className="w-full text-lg sm:text-2xl text-gray-500 text-center py-16 sm:py-20">
                Doctor has no OPD center. Please contact the doctor, or search again.
              </div>
            </Card>
          </div>
        :
        <div className="w-full px-2 sm:px-4 pb-4">
          <LoadingContainer text={"Getting doctor's profile"} />
        </div>
      }

      {selectedCenter && <AddOpdOnline title={`Create Appointment for ${centerName}`} centerData={selectedCenter} addOpdOnline={addOpdOnline} isOpen={isOpenAdd} setIsOpen={setIsOpenAdd} loding={lodingCrud} centerId={centerId} />}
    </MasterPage>
  );
}